import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { DynamicEffectsService } from '../../services/dynamic-effects.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {

  constructor(private dynamicEffectsService: DynamicEffectsService) {}

  ngOnInit(): void {
    // Component initialization
  }

  ngAfterViewInit(): void {
    // Re-initialize scroll animations specifically for home page elements
    setTimeout(() => {
      this.dynamicEffectsService.initScrollAnimations();
    }, 100);
  }

  ngOnDestroy(): void {
    // Component cleanup
  }

}


